import {Component, ContentChild, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {CloStepNavigationItem} from './step-navigation-item/stepnavigationitem';

/**
 * A progress indicator component communicates to the user the progress of a particular process.
 */

@Component({
  selector: 'clo-step-navigation',
  templateUrl: './stepnavigation.html',
  styleUrls: ['./stepnavigation.scss']
})


export class CloStepNavigation implements OnInit {

  @ContentChildren(CloStepNavigationItem) items: QueryList<CloStepNavigationItem>;

  constructor() {
  }

  ngOnInit() {

  }

  itemClicked(event) {
    console.log(event);
  }

  clearOtherItems(item) {
    this.items.forEach(i => i.setSelected(false));
  }
}
